// ** React Imports
import React, { memo } from 'react';
// ** Component Imports
import ImageIcon from '../../../../../../shared/components/images/image-icon';
import { Images } from '../../../../../../shared/app-constants';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
// ** SCSS Imports
import './ai-credit-capsule.scss';

interface IProps {
  credits: string;
  unit?: string;
  showApproximation?: boolean;
  showPerUnit?: boolean;
  className?: string;
  showBorder?: boolean;
  onClick?: () => void;
  iconClassName?: string;
}

/**
 * Ai Credit Capsule
 * @description Ai Credit Capsule is a component that displays the credits and the unit
 * @param credits - The credits to display
 * @param unit - The unit to display
 * @param showApproximation - Whether to show the approximation
 * @param showPerUnit - Whether to show the per unit
 * @param className - The class name to apply
 * @param showBorder - Whether to show the border
 * @param onClick - The onClick handler
 * @param rest - The rest props
 */
const AiCreditCapsule: React.FC<IProps> = ({
  credits = '1-3',
  unit = 'Row',
  showApproximation = true,
  showPerUnit = true,
  className = '',
  showBorder = false,
  onClick = null,
  iconClassName = '',
  ...rest
}) => (
  <div
    className={`ai-credit-capsule ${showBorder ? 'show-border' : ''} ${
      onClick ? 'clickable' : ''
    } ${className}`}
    {...rest}
    {...(onClick ? accessibleOnClick(onClick) : {})}
  >
    <ImageIcon
      src={Images?.AiCredits}
      alt="Ai Credits"
      className={iconClassName}
    />
    <span className="ai-credit-capsule-text ">
      {`${showApproximation ? '~' : ''}${credits} ${
        showPerUnit ? `/ ${unit}` : ''
      }`}
    </span>
  </div>
);
export default memo(AiCreditCapsule);
